(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5292],{

/***/ 5292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_microdata_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20281);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53711);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var CollapseItem = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(15680), __webpack_require__.e(32809)]).then(__webpack_require__.bind(__webpack_require__, 32809));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32809)
            ];
        }
    }
});
var FAQ = function(param) {
    var faqList = param.faqList, isArticalPage = param.isArticalPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    id: "JSON-LD-faq",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify((0,utils_microdata_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFaqMicrodata */ .T8)({
                            faqList: faqList
                        }), null, 2)
                    }
                }, "JSON-LD-faq")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().frequentlyAskedQuestions), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().faqArticalPage), isArticalPage)),
                children: faqList.map(function(faq) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollapseItem, {
                        faq: faq
                    }, "faq-item/".concat(faq.question));
                })
            })
        ]
    });
};
FAQ.defaultProps = {
    faqList: [],
    isArticalPage: false
};
FAQ.propTypes = {
    faqList: prop_types__WEBPACK_IMPORTED_MODULE_7___default().instanceOf(Array),
    isArticalPage: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool)
};
/* harmony default export */ __webpack_exports__["default"] = (FAQ);


/***/ }),

/***/ 53711:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"frequentlyAskedQuestions":"styles_frequentlyAskedQuestions__qQ4jH","faqArticalPage":"styles_faqArticalPage__d8gOB"};

/***/ })

}]);